import React from "react";
import { useResourcesState } from "@/state/resourcesState";
import { useEditorState } from "@/state/editorState";
import { MaterialSlotEditor } from "./MaterialSlotEditor";
import { MaterialMappingEditor } from "./MaterialMappingEditor";

export const MaterialEditor = () => {
    const { materials, isLoaded } = useResourcesState();
    const { model } = useEditorState();
    const materialSlots = useEditorState((state) => state.materialSlots);
    const setMaterialSlots = useEditorState((state) => state.setMaterialSlots);

    if (!isLoaded) {
        return <div>Loading...</div>;
    }

    return (
        <div className="d-flex flex-column gap-2">
            <div>
                <b>Настройки материалов</b>
            </div>
            {model && <MaterialMappingEditor model={model} materialSlots={materialSlots} />}
            <MaterialSlotEditor
                materials={Object.values(materials)}
                materialSlots={materialSlots}
                setMaterialSlots={setMaterialSlots}
            />
        </div>
    );
};
